import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { DashboardType } from "../Types/types";
import { RootState } from "../../Core/Store";

const initialState: DashboardType = {
  resetCounter: 0,
  exportCounter: 0,
  positionData: [
    { col: 1, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
    { col: 1, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
    { col: 1, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
    { col: 1, colSpan: 3, rowSpan: 3 },
    { col: 4, colSpan: 3, rowSpan: 3 },
  ],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    updateDashboard: (state, action: PayloadAction<DashboardType>) => {
      return action.payload;
    },
  },
});

export const { updateDashboard } = dashboardSlice.actions;

export const getDashboardExportSelector = (state: RootState) =>
  state.dashboard.exportCounter;

export const getDashboardResetSelector = (state: RootState) =>
  state.dashboard.resetCounter;
export const getDashboardPositionDataSelector = (state: RootState) =>
  state.dashboard.positionData;

export default dashboardSlice.reducer;
